
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"cfafe3bbe6952db55eca7ee240397a2ca893e5ee":"generateCsvMapping"} */ export var generateCsvMapping = createServerReference("cfafe3bbe6952db55eca7ee240397a2ca893e5ee");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

